export default {
  nav: {
    cta: 'Get in touch',
    contact: 'Contact'
  },
  hero: {
    headline: 'We make sense\nof your <em>obligations</em>.',
    lede: 'Orchestratio is a Dutch regulatory technology company.<br>We build the data layer behind regulations —<br>the platform to <em>discover</em>, <em>organise</em>, and <em>ask</em> what applies.',
    stat1num: '22k+',
    stat1label: 'Laws',
    stat2num: 'NL & EU',
    stat2label: 'Regulations',
    stat3num: '2025',
    stat3label: 'Founded',
    workingOn: 'Working on:'
  },
  contact: {
    eyebrow: 'Get in touch',
    title: 'Contact.',
    lede: 'Got a question, idea, or proposal? Drop us a line and we\'ll get back to you.',
    companyDetails: 'Company details',
    legalName: 'Legal name',
    tradingNames: 'Trading names',
    address: 'Address',
    country: 'Netherlands',
    vat: 'VAT',
    sendMessage: 'Send a message',
    name: {
      label: 'Your name',
      placeholder: 'John Smith'
    },
    email: {
      label: 'Your email address',
      placeholder: 'john@example.com'
    },
    message: {
      label: 'Message',
      placeholder: 'Write your message here...'
    },
    submit: 'Send message',
    submitting: 'Sending...',
    success: {
      title: 'Thank you for your message',
      text: 'We\'ve received your message and you\'ll receive a confirmation by email. We\'ll try to respond as soon as possible.',
      back: 'Back to home'
    },
    error: {
      name: 'Enter your name.',
      email: 'Enter your email address.',
      emailInvalid: 'Enter a valid email address.',
      message: 'Write a message.',
      submit: 'Something went wrong. Please try again later.'
    }
  },
  notfound: {
    eyebrow: '404',
    title: 'Lost in space.',
    lede: 'This page seems to have drifted off course. Let\'s get you back.',
    backHome: 'Back to home'
  },
  meta: {
    home: {
      title: 'Orchestratio — We make sense of your obligations',
      description: 'Orchestratio is a Dutch regulatory technology company. We build the data layer behind regulations — the platform to discover, organise, and ask what applies.'
    },
    contact: {
      title: 'Contact us — Orchestratio',
      description: 'Get in touch with Orchestratio. Questions about regulatory technology, obligations, or our platform? Drop us a line.'
    },
    notfound: {
      title: '404 — Orchestratio',
      description: 'Page not found.'
    }
  },
  footer: {
    copyright: '© 2026 Orchestratio B.V.',
    contact: 'Contact'
  }
}
